import { IPurchaseStateLineItem } from "@smartrr/shared/entities/PurchaseState/CustomerPurchaseLineItem";
import { BundleLineItemTypes } from "@smartrr/shared/utils/bundles";

/**
 * Retrieves the first available line item from a list of Purchase State line items
 * that can be selected for a specific delivery schedule index.
 *
 * This function filters out line items that are add-ons and those not associated
 * with the specified delivery schedule index.
 *
 * @param lines - An array of Purchase State line items to search through.
 * @param skdIdx - The delivery schedule index to filter line items by.
 * @returns The first matching line item for selection, or undefined if more than one is found.
 */
export const getFirstAvailableLineItemForSelection = (
  lines: IPurchaseStateLineItem[],
  skdIdx: number
): IPurchaseStateLineItem | undefined => {
  if (!lines) {
    return;
  }

  const filteredLineItems = lines.filter(li => {
    let condition = true;

    // checking scheduled index
    condition = condition && (li.skdIdx === skdIdx || typeof li.skdIdx === "undefined" || li.skdIdx === null);

    // checking bundle properties
    condition =
      condition &&
      li.bundleType !== BundleLineItemTypes.BUNDLE_LINE &&
      li.bundleType !== BundleLineItemTypes.BUNDLE_PRODUCT;

    condition = condition && !!li.vnt && !li.isAddOn;
    return condition;
  });

  if (filteredLineItems.length === 1) {
    return filteredLineItems[0];
  }

  return;
};
